require('./template-news/news-facetwp');
require('./common/filters-carousel');
